module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "padding-top": "1rem",
      "padding-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline"
  }, [_c('div', {
    staticClass: "column is-narrow has-text-left"
  }, [_c('h1', {
    staticClass: "main-header",
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "column subnav-links"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96ad16c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 926
// module chunks = 1